module.exports = __webpack_public_path__ + "static/media/empty_order.ee59f09f.png";